import React from "react";

const SvgTradingArrows = props => (
  <svg
    className="trading__arrows"
    width="643px"
    height="305px"
    viewBox="0 0 643 305"
    {...props}
  >
    <g id="vertical-arrow">
      <path
        id="vertical-arrow__line"
        d="M 120.67171,0.61655575 V 89.778075"
        style={{
          fill: "none",
          fillRule: "evenodd",
          stroke: "#ffffff",
          strokeWidth: 1
        }}
      />
      <polyline
        transform="translate(112.86357)"
        points="4 -7 -4 0 4 7"
        id="vertical-arrow__head"
        style={{
          fill: "none",
          fillRule: "evenodd",
          stroke: "#ffffff",
          strokeWidth: 1
        }}
      />
    </g>
    <g id="chart-arrow">
      <g
        transform="translate(339.91904,38.69243)"
        id="chart-arrow__chart"
        style={{
          fill: "none",
          fillRule: "evenodd",
          stroke: "none",
          strokeWidth: 1
        }}
      >
        <path
          style={{
            fill: "#adbad0"
          }}
          id="Fill-43"
          d="M 37.880523,12.162639 42.978649,7.0631035 C 33.360602,-2.5513768 17.475075,-2.3248746 7.5614525,7.5872944 6.2561769,8.8923787 5.1299722,10.294535 4.1655785,11.776507 L 10.08139,15.53213 c 0.699023,-1.054853 1.499448,-2.051463 2.437952,-2.98983 7.095953,-7.0970695 18.480977,-7.2588568 25.361181,-0.379661"
        />
        <path
          style={{
            fill: "#009ee3"
          }}
          id="Fill-45"
          d="m 42.979297,7.0637507 -5.100284,5.0995363 c 4.362425,4.359628 5.883449,10.490289 4.636425,16.217559 l 6.938457,1.350385 C 51.197139,21.723838 49.065549,13.149111 42.979297,7.0637507"
        />
        <path
          style={{
            fill: "#fddd00"
          }}
          id="Fill-47"
          d="m 49.453895,29.730799 -6.938457,-1.348227 c -0.731385,3.347919 -2.384015,6.546993 -4.994567,9.157161 -1.939574,1.937134 -4.211401,3.337133 -6.616992,4.234514 l 2.321449,6.641908 c 3.352724,-1.253313 6.537165,-3.207703 9.251276,-5.921416 3.650456,-3.649921 5.965433,-8.106622 6.977291,-12.76394"
        />
        <path
          style={{
            fill: "#ffffff"
          }}
          id="Fill-49"
          d="M 10.083979,15.532346 4.16601,11.776723 c -6.3731968,9.780582 -5.4541102,22.855153 2.8953386,31.201221 6.9988664,6.997841 17.2684724,8.781815 26.1616064,5.440368 L 30.903663,41.776404 C 24.515364,44.157913 17.173459,42.895972 12.159475,37.880565 6.1724667,31.892278 5.5209076,22.553915 10.083979,15.532346"
        />
      </g>
      <path
        d="m 365.07183,89.68296 v 32.05592 c 0,8.83656 -7.16344,16 -16,16 h -34.07188"
        id="chart-arrow__line"
        style={{
          fill: "none",
          fillRule: "evenodd",
          stroke: "#ffffff",
          strokeWidth: 1,
          strokeDasharray: "3, 3"
        }}
      />
      <polyline
        transform="translate(314.99995,89.682962)"
        id="chart-arrow__head"
        points="4 -7 -4 0 4 7"
        style={{
          fill: "none",
          fillRule: "evenodd",
          stroke: "#ffffff",
          strokeWidth: 1
        }}
      />
    </g>
    <g id="dollar-arrow">
      <path
        style={{
          fill: "none",
          fillRule: "evenodd",
          stroke: "#fddd00",
          strokeWidth: 2
        }}
        id="dollar-arrow__line"
        d="M 256.79103,49.667982 V 89.599247"
      />
      <polyline
        transform="translate(244.64873,26.554185)"
        style={{
          fill: "none",
          fillRule: "evenodd",
          stroke: "#fddd00",
          strokeWidth: 2
        }}
        points="4 -7 -4 0 4 7"
        id="dollar-arrow__head"
      />
      <g id="dollar-arrow__icon">
        <path
          d="m 256.79103,50.833067 c -6.70545,0 -12.1423,-5.436054 -12.1423,-12.14052 0,-6.704466 5.43685,-12.138362 12.1423,-12.138362 6.70329,0 12.1423,5.433896 12.1423,12.138362 0,6.704466 -5.43901,12.14052 -12.1423,12.14052 z"
          id="Stroke-65"
          style={{
            fill: "none",
            fillRule: "evenodd",
            stroke: "#fedd00",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }}
        />
        <path
          d="m 255.97787,45.440157 v -1.572573 c -1.10894,-0.04962 -2.18337,-0.362404 -2.81119,-0.709707 l 0.49406,-1.934976 c 0.69471,0.379661 1.66989,0.726964 2.74647,0.726964 0.96008,0 1.60517,-0.379661 1.60517,-1.022496 0,-0.629892 -0.53074,-1.02681 -1.77129,-1.440985 -1.76914,-0.595378 -2.97733,-1.421571 -2.97733,-3.024344 0,-1.471186 1.02697,-2.614483 2.79394,-2.942372 v -1.572573 h 1.62027 v 1.453929 c 1.09384,0.03451 1.83817,0.282588 2.41853,0.547919 l -0.49837,1.865947 c -0.41208,-0.196301 -1.18878,-0.57812 -2.38186,-0.57812 -1.07227,0 -1.42178,0.478891 -1.42178,0.942681 0,0.528505 0.5782,0.893066 2.00214,1.404314 1.96762,0.694607 2.74432,1.60493 2.74432,3.110631 0,1.471186 -1.02481,2.728812 -2.92771,3.041601 v 1.70416 z"
          id="Fill-67"
          style={{
            fill: "#fddd00",
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 1
          }}
        />
      </g>
    </g>
    <g id="bent-arrow">
      <polyline
        transform="translate(344.60846,135.68296)"
        style={{
          fill: "none",
          fillRule: "evenodd",
          stroke: "#fedd00",
          strokeWidth: 1,
          strokeLinecap: "round"
        }}
        points="4 -7 -4 0 4 7"
        id="bent-arrow__head"
      />
      <path
        style={{
          fill: "none",
          fillRule: "evenodd",
          stroke: "#fddd00",
          strokeWidth: 1,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeDasharray: "5, 3"
        }}
        id="bent-arrow__line"
        d="m 642.99995,135.68296 h -138.2703 c -8.83655,0 -16,7.16344 -16,16 v 30.8177 c 0,8.83655 -7.16344,16 -16,16 H 346.01557"
      />
    </g>
    <path
      style={{
        fill: "#6b87ba",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: 1
      }}
      d="m 182.04776,66.14332 c 0,-1.16703 0.86515,-2.11187 1.9331,-2.11187 1.07011,0 1.9331,0.94484 1.9331,2.11187 0,1.16702 -0.86299,2.11186 -1.9331,2.11186 -1.06795,0 -1.9331,-0.94484 -1.9331,-2.11186 z m 5.53695,0 c 0,-1.16703 0.86515,-2.11187 1.93311,-2.11187 1.07011,0 1.9331,0.94484 1.9331,2.11187 0,1.16702 -0.86299,2.11186 -1.9331,2.11186 -1.06796,0 -1.93311,-0.94484 -1.93311,-2.11186 z m 5.5389,0 c 0,-1.16703 0.863,-2.11187 1.93311,-2.11187 1.06795,0 1.9331,0.94484 1.9331,2.11187 0,1.16702 -0.86515,2.11186 -1.9331,2.11186 -1.07011,0 -1.93311,-0.94484 -1.93311,-2.11186 z m 5.53696,0 c 0,-1.16703 0.86515,-2.11187 1.9331,-2.11187 1.07011,0 1.93311,0.94484 1.93311,2.11187 0,1.16702 -0.863,2.11186 -1.93311,2.11186 -1.06795,0 -1.9331,-0.94484 -1.9331,-2.11186 z m 5.53912,0 c 0,-1.16703 0.86299,-2.11187 1.9331,-2.11187 1.06795,0 1.9331,0.94484 1.9331,2.11187 0,1.16702 -0.86515,2.11186 -1.9331,2.11186 -1.07011,0 -1.9331,-0.94484 -1.9331,-2.11186 z m 5.53695,0 c 0,-1.16703 0.86515,-2.11187 1.93311,-2.11187 1.06795,0 1.9331,0.94484 1.9331,2.11187 0,1.16702 -0.86515,2.11186 -1.9331,2.11186 -1.06796,0 -1.93311,-0.94484 -1.93311,-2.11186 z m 5.53696,0 c 0,-1.16703 0.86515,-2.11187 1.9331,-2.11187 1.07011,0 1.93311,0.94484 1.93311,2.11187 0,1.16702 -0.863,2.11186 -1.93311,2.11186 -1.06795,0 -1.9331,-0.94484 -1.9331,-2.11186 z m -27.68889,5.76588 c 0,-1.16702 0.86515,-2.11186 1.93311,-2.11186 1.07011,0 1.9331,0.94484 1.9331,2.11186 0,1.16703 -0.86299,2.11187 -1.9331,2.11187 -1.06796,0 -1.93311,-0.94484 -1.93311,-2.11187 z m 5.5389,0 c 0,-1.16702 0.863,-2.11186 1.93311,-2.11186 1.06795,0 1.9331,0.94484 1.9331,2.11186 0,1.16703 -0.86515,2.11187 -1.9331,2.11187 -1.07011,0 -1.93311,-0.94484 -1.93311,-2.11187 z m 5.53696,0 c 0,-1.16702 0.86515,-2.11186 1.9331,-2.11186 1.07011,0 1.93311,0.94484 1.93311,2.11186 0,1.16703 -0.863,2.11187 -1.93311,2.11187 -1.06795,0 -1.9331,-0.94484 -1.9331,-2.11187 z m 5.53912,0 c 0,-1.16702 0.86299,-2.11186 1.9331,-2.11186 1.06795,0 1.9331,0.94484 1.9331,2.11186 0,1.16703 -0.86515,2.11187 -1.9331,2.11187 -1.07011,0 -1.9331,-0.94484 -1.9331,-2.11187 z m 5.53695,0 c 0,-1.16702 0.86515,-2.11186 1.93311,-2.11186 1.06795,0 1.9331,0.94484 1.9331,2.11186 0,1.16703 -0.86515,2.11187 -1.9331,2.11187 -1.06796,0 -1.93311,-0.94484 -1.93311,-2.11187 z m -16.61303,5.76589 c 0,-1.16703 0.863,-2.11187 1.93311,-2.11187 1.06795,0 1.9331,0.94484 1.9331,2.11187 0,1.16702 -0.86515,2.11186 -1.9331,2.11186 -1.07011,0 -1.93311,-0.94484 -1.93311,-2.11186 z m 5.53696,0 c 0,-1.16703 0.86515,-2.11187 1.9331,-2.11187 1.07011,0 1.93311,0.94484 1.93311,2.11187 0,1.16702 -0.863,2.11186 -1.93311,2.11186 -1.06795,0 -1.9331,-0.94484 -1.9331,-2.11186 z m 5.53912,0 c 0,-1.16703 0.86299,-2.11187 1.9331,-2.11187 1.06795,0 1.9331,0.94484 1.9331,2.11187 0,1.16702 -0.86515,2.11186 -1.9331,2.11186 -1.07011,0 -1.9331,-0.94484 -1.9331,-2.11186 z m -5.53912,5.76566 c 0,-1.16702 0.86515,-2.11186 1.9331,-2.11186 1.07011,0 1.93311,0.94484 1.93311,2.11186 0,1.16703 -0.863,2.11187 -1.93311,2.11187 -1.06795,0 -1.9331,-0.94484 -1.9331,-2.11187 z"
      id="Combined-Shape"
    />
    <g
      style={{
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: 1
      }}
      id="Group-11"
      transform="translate(0,162.8313)"
    >
      <polygon
        style={{
          fill: "#009ee3"
        }}
        id="Fill-37"
        points="5.2901417,39.458846 -1.3677948e-13,39.458846 14.944866,19.729423 -1.3677948e-13,-5.6843419e-14 5.2901417,-5.6843419e-14 20.235008,19.729423 "
      />
      <polygon
        style={{
          fill: "#fddd00"
        }}
        id="Fill-39"
        points="15.253817,39.458846 9.9636756,39.458846 24.908542,19.729423 9.9636756,-5.6843419e-14 15.253817,-5.6843419e-14 30.198684,19.729423 "
      />
      <polygon
        style={{
          fill: "#009ee3"
        }}
        id="Fill-41"
        points="25.217277,39.458846 19.929293,39.458846 34.874159,19.729423 19.929293,-5.6843419e-14 25.217277,-5.6843419e-14 40.162143,19.729423 "
      />
    </g>
  </svg>
);

export default SvgTradingArrows;




// WEBPACK FOOTER //
// ./frontend/pages/InfographicLanding/TradingArrows.jsx